// @flow
import * as React from 'react';
import styled from 'styled-components';
import LoadingSpinner from 'common/components/LoadingSpinner';

const Container = styled.div`
  min-width: ${({ responsive }) => (responsive ? '350px' : '968px')};
`;

const CenterWrapper = styled.div`
  justify-content: center;
  text-align: center;
  margin-top: 25vh;
  margin-left: auto;
  margin-right: auto;
`;

interface Props {
  responsive?: boolean;
  loading?: boolean;

  children: any;
}

function Page(props: Props) {
  return (
    <Container responsive={props.responsive}>
      { props.loading &&
        <CenterWrapper>
          <LoadingSpinner size="large" />
        </CenterWrapper>
      }
      { !props.loading &&
        props.children
      }
    </Container>
  );
}

export default Page;



// WEBPACK FOOTER //
// ./src/advertisers/components/PageContainer.js